import { usePage } from '@inertiajs/vue3'

export function useNavigation() {
  const getHref = (href) => {
    if (href === null) {
      return ''
    }

    const language = usePage().props?.session?.language || 'en'
    const localeHref = href[language] ?? href

    // Check if the href contains auth and guest properties
    if (localeHref && typeof localeHref === 'object' && 'auth' in localeHref && 'guest' in localeHref) {
      // Use auth URL if authenticated, otherwise use guest URL
      return usePage().props.auth ? localeHref.auth : localeHref.guest
    }

    return localeHref
  }

  return {
    getHref
  }
}
